import { Dialog } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { NavigationItem } from '@models';
import {
  AuthenticationService,
  MeService,
  NavigationService,
  SupportTicketsService,
} from '@services';
import { SupportTicketDialogComponent } from '@ui-lib';
import { AddProviderDialogComponent } from '../../providers/add-provider-dialog/add-provider-dialog.component';
import { PATIENTS_ROUTE } from '../../patients/patient-data.guard';

@Component({
  selector: 'admin-portal-sidebar-menu',
  imports: [NgClass, MatIconModule, RouterModule, RouterLink],
  templateUrl: './admin-portal-sidebar-menu.component.html',
})
export class AdminPortalSidebarMenuComponent {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly navigationService = inject(NavigationService);
  private readonly meService = inject(MeService);
  private readonly router = inject(Router);
  private readonly dialog = inject(Dialog);

  readonly me = this.meService.me;

  navItems = computed(
    () =>
      this.navigationService
        .getItems()
        .filter(
          item =>
            item.route !== PATIENTS_ROUTE ||
            this.me()?.canAccessPatientData === true
        )
        .map(item =>
          item.children && item.children.length > 0
            ? { ...item, collapsed: false }
            : item
        ) as (NavigationItem & { collapsed: boolean })[]
  );

  get fullName(): string | undefined {
    const current = this.me();
    return current ? `${current.givenName} ${current.familyName}` : undefined;
  }

  get email(): string | null | undefined {
    return this.me()?.email;
  }

  get isSidebarOpen(): boolean {
    return this.navigationService.isSidebarOpen();
  }

  closeSidebar(): void {
    this.navigationService.closeSidebar();
  }

  logout(): void {
    this.authenticationService.logout(true);
    this.router.navigate(['/auth']);
  }

  openSupportTicketDialog(): void {
    this.dialog.open(SupportTicketDialogComponent, {
      providers: [{ provide: SupportTicketsService }],
    });
  }

  openAddProviderDialog(): void {
    this.dialog.open(AddProviderDialogComponent);
  }
}
